export const IMAGE_ACCEPT = ".jpg,.jpeg,.jfif,.pjpeg,.pjp,.png,.webp,.gif";
export const VIDEO_ACCEPT =
  ".mp4, .avi, .mkv, .mov, .wmv, .flv, .3gp, .ogg, .mpeg, .mpg";
export const PDF_ACCEPT = "application/pdf";
